<template>
    <div>
        <div class="bg-growth rounded-full text-white p-2 fixed z-50 top-5 px-6 left-1/2" v-if="saved">{{ $t('saved') }}</div>

        <div v-if="loading" class="state-changed w-full h-20 fixed border-0 top-0 left-0 z-50"></div>   
        <div class="w-full mb-4 relative">
        <router-link :to="'../Settings'">
            <font-awesome-icon icon="fas fa-arrow-left" class="float-left text-lg p-2 text-button dark:text-dark.textOnBkg -mt-2" />
        </router-link>
        <h2 class="mt-2 text-xl font-semibold text-center">{{ $t('salary_settings.headline') }}</h2>
        <p class="mt-2 text-sm text-center">{{ $t('salary_settings_notice') }}</p>
        </div>

        <div class="min-w-52 block mb-10">
            <p class="font-bold bold mt-5 mb-1">{{ $t('wage_based_on') }}:</p>
            <slot v-for="(sType,index) in salaryTypes" :key="index">
                <MazRadio
                    v-if="index != 0"
                    v-model="salaryType"
                    class="mr-5"
                    name="chosenColor"
                    :value="index"
                >{{ sType }}
                </MazRadio>
            </slot>
            
            <slot v-if="salaryType == 2 && !loading">
                <base-salary-component :salary="baseSalary" :sHours="baseSalaryH" />
                <salary-table :salaryType="salaryType" :salary="monthlySalary" />
            </slot>

            <salary-table v-else-if="salaryType == 1 && !loading" :salaryType="salaryType" :salary="salary" />
            <div class="mt-10 text-button dark:text-growth" v-else>{{ $t('salary_settings.notice') }}</div>
        </div>
    </div>
</template>

<script setup>
    import salaryTable from './salary/salaryTable.vue'
    import baseSalaryComponent from './salary/baseSalaryComponent.vue'
</script>
<script>
    import { api_post_call, api_get_call } from '@/api/api.js';
    export default {
        components: { salaryTable,baseSalaryComponent },
        data() {
            return { 
                salary: [],
                monthlySalary: [],
                baseSalary:0,
                baseSalaryH:0,
                salaryMonth: [],
                modelPairID: null,
                sortColumn: null,
                loading:false,
                editIndex: null,
                salaryType: 1,
                addingNewLine: false,
                rozdielOK: false,
                saved: false,
                salaryTypes: [this.$t('fixed_wage'), this.$t('earnings') + '/' + this.$t('shift_settings[6]'), this.$t('earnings') + '/' + this.$t('month')],
            }
        },
        watch: {
            salaryType: function (val) {
                this.changeSalary(val);
            }
        },
        methods: {
            async changeSalary(val) {
                this.salaryType = val;

                const response = await api_post_call("settingspost/", {
                    action: 'salaryType',
                    type: this.salaryType,
                    userToken: this.$cookies.get('userToken'),
                    companyID: this.$cookies.get('c_id')
                });
                if (response) {
                    setTimeout(() => (this.saved = false),500);         
                }
            },
        },
        async mounted() {
            this.loading = true;
            const response = await api_get_call(`settingsget/?action=getSalarySettings&userToken=${this.$cookies.get('userToken')}&companyID=${this.$cookies.get('c_id')}`);
            if (response) {
                this.salary = response.salaryLevels
                this.monthlySalary = response.salaryMonth
                this.salaryType = response.type;
                this.baseSalaryH = response.monthlyBased?.hours
                this.baseSalary = response.monthlyBased?.salary
                this.loading = false;
                console.log(this.salaryType);
            }
        }
    }
</script>